import { TextureLoader, VideoTexture } from 'three'
import EventEmitter from './EventEmitter.js'
import UI from "../UI/UI";
// import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
// import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        this.ui = UI.getInstance();

        this.sources = sources

        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0
        this.loadedAll = false

        this.setLoaders()
        this.startLoading()
    }

    setLoaders()
    {
        this.loaders = {}
        this.loaders.textureLoader = new TextureLoader()
        // draco loader
        /*const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath( `${ window.theme_assets_url }/js/vendors/draco/` )
        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.gltfLoader.setDRACOLoader( dracoLoader )*/
    }

    startLoading()
    {
        // Load each source
        for(const source of this.sources)
        {
            if(source.type === 'texture') {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            /*else if(source.type === 'cubeTexture') {
                new RGBELoader().load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if(source.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) =>
                    {
                        this.sourceLoaded(source, file)
                    }
                )
            }*/
            else if ( source.type === 'videoTexture' ) {
                let videoElement = document.createElement( 'video' )
                videoElement.src = source.path
                videoElement.setAttribute( 'crossorigin', 'anonymous' )
                videoElement.muted = true
                videoElement.loop = true
                videoElement.load()
                videoElement.setAttribute( 'playsinline', '' )
                videoElement.setAttribute( 'webkit-playsinline', '' )
                // videoElement.play()
                videoElement.pause()
                // handle error
                videoElement.onerror = () => {
                    this.sourceError(source)
                }

                const obj = {
                    videoTexture : new VideoTexture( videoElement ),
                    videoElement : videoElement,
                    videoWidth : 0,
                    videoHeight : 0,
                    isVideoTexture : true,
                    isGalleryObject: true
                }

                videoElement.addEventListener( 'canplaythrough', () => {
                    obj.videoWidth = videoElement.videoWidth
                    obj.videoHeight = videoElement.videoHeight
                    this.sourceLoaded( source, obj )
                }, { once: true} )
            }
        }

        if(this.sources.length === 0) {
            setTimeout(() => {
                this.loadedAll = true
                this.trigger('ready')
            });
        }
    }

    sourceError(source) {
        this.items[source.name] = null
        this.handleLoading()
    }

    sourceLoaded(source, file)
    {
        this.items[source.name] = file
        this.handleLoading()
    }

    handleLoading() {
        this.loaded++

        this.loadedPercentage = this.loaded / this.toLoad
        this.ui.setPreloaderProgress(this.loadedPercentage * 100)
        if(this.loaded === this.toLoad)
        {
            this.loadedAll = true
            this.trigger('ready')
        }
    }
}
